// TradingViewWidget.jsx
import React, { useEffect, useRef, memo, useMemo } from 'react';

function TradingViewWidget({ leftSideName, exchange = 'COINBASE', height = 480 }) {
  const containerRef = useRef(null);

  const tvSymbol = useMemo(() => {
    const base = (leftSideName || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    return `${exchange}:${base}USD`;
  }, [leftSideName, exchange]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.innerHTML = ''; // clear previous

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify({
      allow_symbol_change: true,
      calendar: false,
      details: false,
      hide_side_toolbar: true,
      hide_top_toolbar: false,
      hide_legend: false,
      hide_volume: false,
      interval: 'D',
      locale: 'en',
      style: '1',
      symbol: tvSymbol,
      theme: 'dark',
      timezone: 'Etc/UTC',
      backgroundColor: '#0F0F0F',
      gridColor: 'rgba(242, 242, 242, 0.06)',
      autosize: true,
    });
    el.appendChild(script);
    return () => { if (el) el.innerHTML = ''; };
  }, [tvSymbol]);

  return (
    <div className="tradingview-widget-container" ref={containerRef}
         style={{ height, width: '100%' }}>
      <div className="tradingview-widget-container__widget"
           style={{ height: '100%', width: '100%' }} />
    </div>
  );
}

export default memo(TradingViewWidget);
